import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  display: block;\n  line-height: 1.14;\n  margin-bottom: 0.5em;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { Heading4 } from '@scp/ui-shared/components/typography';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_LABEL_SUFFIX = '-label';
var TEXT = {
  OPTIONAL_LABEL: '(optional)'
};
var LabelElement = styled(Heading4)(_templateObject(), function (props) {
  return props.disabled || !props.htmlFor && !props.onClick ? 'default' : 'pointer';
}, function (props) {
  return props.truncate && ellipsis();
});
var HiddenLabel = VisuallyHiddenElement.withComponent(LabelElement);
/**
 * @example ./__docs__/Label.md
 */

export var Label = function Label(_a) {
  var _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$visuallyHidden = _a.visuallyHidden,
      visuallyHidden = _a$visuallyHidden === void 0 ? false : _a$visuallyHidden,
      _a$truncate = _a.truncate,
      truncate = _a$truncate === void 0 ? false : _a$truncate,
      _a$as = _a.as,
      as = _a$as === void 0 ? 'label' : _a$as,
      _a$children = _a.children,
      children = _a$children === void 0 ? '' : _a$children,
      isOptional = _a.isOptional,
      dataE2e = _a.dataE2e,
      props = __rest(_a, ["disabled", "visuallyHidden", "truncate", "as", "children", "isOptional", "dataE2e"]);

  var dataE2eLabel = getE2eLabel(dataE2e, E2E_LABEL_SUFFIX);
  if (visuallyHidden) return React.createElement(HiddenLabel, Object.assign({}, props, {
    as: as,
    "data-e2e": dataE2eLabel
  }), children, isOptional ? " ".concat(TEXT.OPTIONAL_LABEL) : null);
  return React.createElement(LabelElement, Object.assign({}, props, {
    as: as,
    truncate: truncate,
    "data-e2e": dataE2eLabel
  }), children, isOptional ? " ".concat(TEXT.OPTIONAL_LABEL) : null);
};